import { LoadManager, PageHeader, Styles } from '@/components'
import useAxiosRequest from '@/hooks/useAxiosRequest'
import useAuth from '@/hooks/useAuth'
import usePageTitle from '@/hooks/usePageTitle'
import PropTypes from 'prop-types'
import castrations from '@/services/api/castrations'
import React, { useState } from 'react'
import Edit from './components/Edit'

function Terms({ title }) {
  usePageTitle({ title })
  const { user, licensing } = useAuth()
  const [editing, setEditing] = useState(false)
  const {
    data, loading, error, setData,
  } = useAxiosRequest(castrations.currentTerms)

  const currentTerms = data?.castrationTerms || ''
  const canEditTerms = licensing?.licensedId === user?.id

  function onUpdate(newTerms) {
    setData({ ...data, castrationTerms: newTerms })
    setEditing(false)
  }

  return (
      <Styles.Container className="grid-xl">
        <PageHeader
          icon="fas fa-file-alt"
          title="Termos da Castração"
          subtitle="Estes são os termos que o usuário deve aceitar para solicitar castrações."
        />
        <LoadManager error={error} loading={loading}>
          <>
            {
              currentTerms
                ? (
                  <>
                    <div className="pre text-justify">
                      {currentTerms}
                    </div>
                    <div className="mt-2 no-print">
                      {canEditTerms && (
                        <a className="c-hand mr-2" onClick={() => setEditing(true)}>
                          <i className="fas fa-edit" />
                          &nbsp;Alterar os termos
                        </a>
                      )}
                      <a className="c-hand ml-2" onClick={() => window.print()}>
                        <i className="fas fa-print" />
                        &nbsp;Imprimir os termos
                      </a>
                    </div>
                  </>
                )
                : (
                  <div className="empty">
                    <div className="empty-icon">
                      <i className="fas fa-3x fa-file-alt" />
                    </div>
                    <p className="empty-title h5">Termo de castração não informado</p>
                    <p className="empty-subtitle">O usuário não precisará concordar com termos para solicitar castrações.</p>
                    {canEditTerms && (
                      <div className="empty-action">
                        <button type="button" onClick={() => setEditing(true)} className="btn btn-primary">
                          <i className="fas fa-plus" />
                          &nbsp;Adicionar termos
                        </button>
                      </div>
                    )}
                  </div>
                )
            }
          </>
        </LoadManager>
        {
          editing && canEditTerms && (
            <Edit onClose={() => setEditing(false)} content={currentTerms} onUpdate={onUpdate} />
          )
        }
      </Styles.Container>
  )
}

Terms.propTypes = {
  title: PropTypes.string.isRequired,
}

export default Terms
